import React from "react";
import {WashnetBackend} from "./WashnetBackend";

export const WashnetContext = React.createContext<WashnetBackend | undefined>(undefined);

